var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16659 10.8599L18.3333 9.33215V13.2611C17.7906 12.988 17.1628 12.8334 16.4999 12.8334C14.5081 12.8334 12.8333 14.2291 12.8333 16.0417C12.8333 17.8544 14.5081 19.2501 16.4999 19.2501C18.4918 19.2501 20.1666 17.8544 20.1666 16.0417V1.66797L7.33325 3.80686V14.1778C6.79062 13.9046 6.16283 13.7501 5.49992 13.7501C3.50807 13.7501 1.83325 15.1457 1.83325 16.9584C1.83325 18.771 3.50807 20.1667 5.49992 20.1667C7.49176 20.1667 9.16659 18.771 9.16659 16.9584V10.8599ZM7.33325 16.9584C7.33325 17.677 6.54564 18.3334 5.49992 18.3334C4.4542 18.3334 3.66659 17.677 3.66659 16.9584C3.66659 16.2397 4.4542 15.5834 5.49992 15.5834C6.54564 15.5834 7.33325 16.2397 7.33325 16.9584ZM16.4999 17.4167C17.5456 17.4167 18.3333 16.7604 18.3333 16.0417C18.3333 15.3231 17.5456 14.6667 16.4999 14.6667C15.4542 14.6667 14.6666 15.3231 14.6666 16.0417C14.6666 16.7604 15.4542 17.4167 16.4999 17.4167ZM9.16658 9.0013V5.35992L18.3333 3.83215V7.47353L9.16658 9.0013Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.1a489c4ee7d562ee215ac2163beb3a03.svg";
export { ForwardRef as ReactComponent };